export default function () {
  return {
    hiddenSchema() {
      return this.schema.filter(item => item.type === 'hidden')
    },
    tabSchema() {
      return this.schema.filter(item => item.asTabFilter)
    },
    editableSchema() {
      return this.schema.filter(item => {
        if (item.editable) {
          if (item.hide) {
            if (typeof item.hide === 'boolean') {
              return !item.hide
            }
            if (typeof item.hide === 'string' && item.hide === this.searchFormData[this.tableSchema[0].key]) {
              return false
            }
            if (Array.isArray(item.hide) && typeof item.hide[0] === 'string' && this.searchFformData[this.tableSchema[0].key] in item.hide) {
              return false
            }
            if (typeof item.hide === 'function') {
              return !item.hide(this.appName)
            }
          }
          return true
        }
        return false
      })
    },
    filterSchema() {
      return this.schema.filter(item => {
        if (item.asFilter && !item.asTabFilter) {
          if (item.hide) {
            if (typeof item.hide === 'boolean') {
              return !item.hide
            }
            if (typeof item.hide === 'string' && item.hide === this.searchFormData[this.tableSchema[0].key]) {
              return false
            }
            if (Array.isArray(item.hide) && typeof item.hide[0] === 'string' && this.searchFformData[this.tableSchema[0].key] in item.hide) {
              return false
            }
            if (typeof item.hide === 'function') {
              return !item.hide(this.searchFormData)
            }
          }
          return true
        }
        return false
      })
    },
    tableSchema() {
      const o = this.schema.filter(item => item.type !== 'hidden').reduce((prev, cur) => ({
        ...prev,
        [cur.key]: cur
      }), {})
      return this.pickedColumns.filter(t => t.visible).map(t => o[t.id])
    },
  }
}



// WEBPACK FOOTER //
// ./packages/utils/mapSchemas.js